module.exports = __webpack_public_path__ + "img/soz_zt.83c435da.jpg";